import { CONTRACT_STATUS_CANCELLED, CONTRACT_STATUS_EXPIRED } from "../../components/pages/my-plan/my-plan.constants";

export const PAGE_VIEW = 'page_view';
export const HIT_TYPE = 'customer';
export const ALL_PAGES = 'All_Pages';
export const ACC_LOGGEDOUT = 'My_Account';
export const ACC_LOGGEDIN = 'My_Account_Loggedin';
export const ACC_VIVR = 'My_Account_VIVR';
export const GUEST = 'Guest';
export const USER_COUNTRY = 'US';
export const OTHER_LABEL = 'OTHER';
export const MYACCOUNT_LOGGEDIN_SR  = 'My_Account_Loggedin_SR';
export const MYACCOUNT_LOGGEDIN_PM  = 'My_Account_Loggedin_PM';
export const MYACCOUNT_VIVR_SR  = 'My_Account_VIVR_SR';
export const MYACCOUNT_VIVR_PM  = 'My_Account_VIVR_PM';
export const UNDEFINED_USERID = 'Undefined_UserId';
export const DASHBOARD = 'Dashboard';
export const MENU = 'Menu';
export const PLAN_DETAILS_PAGE = 'PLAN_DETAILS_PAGE';
export const PAYMENT_HISTORY_PAGE = 'PAYMENT_HISTORY_PAGE';
export const TEMPLATE_COMPLETE = 'Complete';
export const EVENT_BUTTON_CLICK = 'button_click';
export const SR_LIST_PAGE = 'SR_LIST_PAGE';
export const SR_STATUS_PAGE = 'SR_STATUS_PAGE';
export const PROFILE_PAGE = 'PROFILE_PAGE';
export const SR_PM_INIT_FLOW_HEADER = 'SR_PM_INIT_FLOW_HEADER';
export const SR_PM_INIT_SPLIT_SCREEN = 'SR_PM_INIT_SPLIT_SCREEN';
export const SR_PM_INIT_CATEGORY_SELECTION_PAGE = 'SR_PM_INIT_CATEGORY_SELECTION_PAGE';
export const SR_PM_INIT_ITEM_SELECTION_PAGE = 'SR_PM_INIT_ITEM_SELECTION_PAGE';
export const SR_PM_INIT_FLOW_SYMPTOMS_PAGE = 'SR_PM_INIT_FLOW_SYMPTOMS_PAGE';
export const SR_PM_INIT_FLOW_REVIEW_PAGE = 'SR_PM_INIT_FLOW_REVIEW_PAGE';
export const SR_PM_INIT_FLOW_CALENDAR_PAGE = 'SR_PM_INIT_FLOW_CALENDAR_PAGE';
export const SR_PM_INIT_FLOW_CONFIRMATION_PAGE = 'SR_PM_INIT_FLOW_CONFIRMATION_PAGE';
export const SR_PM_INIT_FLOW_PAYMENT_PAGE = 'SR_PM_INIT_FLOW_PAYMENT_PAGE';
export const SR_PM_ADD_CATEGORY_SELECTION_PAGE = 'SR_PM_ADD_CATEGORY_SELECTION_PAGE';
export const SR_PM_ADD_ITEM_SELECTION_PAGE = 'SR_PM_ADD_ITEM_SELECTION_PAGE';
export const PREFERENCES_PRIVACY_POLICY = 'Privacy_Policy';
export const PREFERENCES_TERMS_OF_USE = 'Terms_Of_Use';
export const VIVR_PAST_DUE_PAYMENT_CONFIRMATION_PAGE = 'VIVR_PAST_DUE_PAYMENT_CONFIRMATION_PAGE';
export const VIVR_SR_DETAILS_PAGE= 'VIVR_SR_DETAILS_PAGE';
export const DOWNLOAD_CLAIM_INSTRUCTIONS_ROOF_LEAK_REPAIR = 'Download_Claim_Instructions_Roof_Leak_Repair';

// Recall claim dialog - "opened from" locations pushed to the datalayer
export const MODAL_OPEN_FROM_DASHBOARD_PAGE = 'Modal_Open_From_Dashboard_page';
export const MODAL_OPEN_FROM_SR_HISTORY_PAGE = 'Modal_Open_From_SR_History_Page';
export const MODAL_OPEN_FROM_SR_DETAILS_PAGE = 'Modal_Open_From_SR_Details_Page';
export const MODAL_OPEN_FROM_LATEST_ACTIVITY = 'Modal_Open_From_CATEGORY_SELECTION_PAGE';

//Events
export const SR_START = 'sr_start';
export const SR_SERVICE_SELECTION = 'sr_service_selection';
export const SR_SCHEDULE = 'sr_schedule';
export const SR_REVIEW = 'sr_review';
export const NEED_PREVENTATIVE_MAINTAINENCE  = 'Need_Preventative_Maintainance'
export const NEED_SERVICE_REQUEST  = 'Need_Service_Request'
export const NEED_CE_SERVICE  = 'Need_CE_Service'

/*Login Page*/
export const LOGIN_PAGE = 'Login_Page';
export const LANDING_PAGE = 'Landing_Page';

//Button Names

/*Login Page*/
export const LOGIN = 'login';
export const FORGOT_PASSWORD = "Forgot_password";
export const SEND_RESET_LINK = "Send_Reset_Link";

export const SAVE_PREFERENCES = 'Save_Preferences';
export const LOGO_HEADER = 'Logo_header';
export const HOME = 'HOME';
export const BACK = 'BACK';
export const CANCEL_PAYMENT = 'CANCEL_PAYMENT';
export const DOWNLOAD_SR_CONFIRMATION_PDF = 'Download_SR_Confirmation_PDF';
export const REMOVE_THE_ITEM = 'Remove_the_Item';
export const REQUEST_SERVICE = 'Request_Service';
export const NEED_SERVICE_AGAIN = 'Need_Service_Again';
export const SIGN_UP = 'sign_up';
export const WHY_CREATE_AN_ACCOUNT = 'Why_Create_an_Cinch_account';
export const WHY_CINCH_ACCOUNT_PAGE = 'Why_Cinch_Account_page';
export const LOGIN_BUTTON = 'Login_button';
export const GET_STARTED_BUTTON = 'Get_Started_button';
export const CREATE_ACCOUNT = 'Create_Account';
export const CREATE_ACCOUNT_REGISTRATION_FLOW = 'Create_Account_Registration_Flow';
export const REGISTRATION_EMAIL_ALREADY_EXISTS_TOAST_MESSAGE = 'Registration_Email_already_Exists_Toast_Message';
export const REGISTRATION_EMAIL_ALREADY_EXISTS_ERROR_MESSAGE = 'Registration_Email_already_Exists_Error_Message';
export const REGISTRATION_EMAIL_ALREADY_EXISTS_LINKS = 'Registration_Email_already_Exists_Links';
export const DOWNLOAD_CLAIM_INSTRUCTIONS_TXU_SURGE = 'Download_Claim_Instructions_TXU_Surge';



/* perks & benefits page */
export const PERKS_PAGE_VENDOR_BUTTON_NAME= 'Re_Key_Vendor_Phone_Number_Click';
export const SPECIAL_BENEFITS_BUTTON_NAME = 'Special_Benefits_Phone_Number_Click';
export const PERKS_BENEFITS_PAGE = 'Perks_And_Benefits_page';
export const SEND_DISCOUNT_CODES = 'Send_me_discount_codes';
export const SEARCH_REKEY_VENDOR = 'Search_ReKey_Vendor';
export const MADE_CC_FEATURES_AND_BENEFITS_VIEW_PDF = 'Made_CC_Features_and_Benefits_View_PDF';
export const HANDYMAN_FEATURES_BENEFITS_CA_VIEW_PDF = 'Handy_man_Benefits_PDF_download_CA';
export const HANDYMAN_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF = 'Handy_man_Benefits_PDF_download_NON_CA';
export const WHOLESALE_CLUB_FEATURES_BENEFITS_CA_VIEW_PDF = 'Wholesale_Club_Benefits_PDF_download_CA';
export const WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF = 'Wholesale_Club_Benefits_PDF_download_NON_CA';
export const DOWNLOAD_CLAIM_INSTRUCTIONS_LOCKSMITH = "Download_Claim_Instructions_Locksmith";
export const APPLIANCE_BUYLINE_COPY_CODE = 'Copy_code';
export const APPLIANCE_BUYLINE_VISIT_STORE_URL = 'Visit_Store_URL';
export const APPLIANCE_BUYLINE_START_SHOPPING = 'Start_shopping';

// contact us page
export const CONTACT_US_PAGE = 'Contact_Us_Page';
export const CONTACT_US_HELP_BUTTON_NAME ='Help_Phone_Number_Click';
export const SUBMIT_CONTACT_CINCH_QUERY = 'Submit_The_Query';
export const GO_BACK_TO_DASHBOARD = 'Go_Back_To_Dashboard';
export const CONTACT_US = 'Contact_Us';
export const SUBMIT_THE_QUERY_EXISTING_JOB = 'Submit_The_Query_Existing_JOB';
export const SUBMIT_THE_QUERY_NEW_JOB = 'Submit_The_Query_New_JOB';
export const SUBMIT_THE_QUERY_PLAN_BILLING = 'Submit_The_Query_Plan_Billing';
export const SUBMIT_THE_QUERY_PLAN_COVERAGE = 'Submit_The_Query_Plan_Coverage';

// Dashboard page
export const DASHBOARD_PAGE_LOCATION = 'Dashboard_Page';
export const CE_PLAN_PHONE_NUMBER_BUTTON = 'CE_Plan_Phone_Number_Click';
export const DASHBOARD_ERROR_PHONE_NUMBER_BUTTON = 'Error_Phone_Number_Click';
export const RETENTION_PHONE_CLICK = 'Retention_Phone_Number_Call_to_Come_Back_CLICK';
export const DASHBOARD_PLAN_LOOKUP_PLAN_NUMBER= 'Plan_lookup_Plan_number';
export const DASHBOARD_PLAN_LOOKUP_MOBILE_NUMBER= 'Plan_lookup_Mobile_number';
export const DASHBOARD_PLAN_LOOKUP_HOUSE_NUMBER= 'Plan_lookup_House_number';
export const ADD_PLAN_BUTTON = 'Add_Plan_button';
export const LOG_OUT = 'Log_out';
export const HAVE_CLAIM_QUESTIONS = 'Have_Claim_Questions';
export const RETENTION_COME_BACK_PLAN_EXPIRED = 'Retention_Phone_Number_Come_Back_Plan_Expired';
export const RETENTION_COME_BACK_PLAN_CANCELLED = 'Retention_Phone_Number_Come_Back_Plan_Cancelled';
export const PHONE_NUMBER_RE_MODAL_UPDATE_NAME = 'Phone_number_RE_modal_update_name';
export const PHONE_NUMBER_RE_MODAL_ERROR_IN_UPDATE = 'Phone_number_RE_modal_error_in_Update';
export const DASHBOARD_LANDING_MODAL = 'Dashboard_Landing_Modal';
export const RE_CUSTOMER_CONTACT_UPDATED = 'RE_Customer_Contact_Updated';
export const RE_MODAL_TO_UPDATE_CONTACT_DISPLAYED = 'RE_Modal_To_Update_Contact_Displayed';
export const RE_MODAL_UPDATE_CONTACT_SUCCESS_MESSAGE_DISPLAYED = 'RE_Modal_Update_Contact_Success_Message_Displayed';
export const RE_MODAL_UPDATE_CONTACT_FAILURE_MESSAGE_DISPLAYED = 'RE_Modal_Update_Contact_Failure_Message_Displayed';
export const UPDATE_BILLING_INFO_FAILURE_MESSAGE_DISPLAYED = 'Update_Billing_Info_Failure_Message_Displayed';

// SR page
export const TYPE_AHEAD_SELECTION_AS_BUTTON = 'Type_ahead_item_selection';
export const ITEM_TAG_PHOTO_UPLOAD_AS_BUTTON = 'IMAGE_Scan_AI_Item_Selection';
export const ITEM_TAG_UNREADABLE_PICTURE_ERROR = 'Item_Tag_Unreadable_Picture_Error';
export const ITEM_TAG_ITEM_NOT_COVERED_ERROR = 'Item_Not_Covered_Error';
export const ITEM_TAG_COMPRESSED_IMAGE_ERROR = 'Compressed_Image_Error';
export const SR_FLOW_OOPS_PAGE = 'SR_FLOW_OOPS_PAGE';
export const ITEM_NOT_COVERED_PHONE_CLICK = "Phone_Number_Click_Item_Not_Covered";

// SR details page
export const TXU_SRG_PHONE_NUMBER_CLICK = 'TXU_SRG_Phone_Number_Click';
export const APO_CINCH_PHONE_NUMBER_CLICK = 'APO_CINCH_Phone_Number_Click';
export const ROOF_LEAK_CINCH_PHONE_NUMBER_CLICK = 'Roof_Leak_CINCH_Phone_Number_Click';
export const BYOP_PHONE_NUMBER_CLICK = 'BYOP_Phone_Number_Click';
export const SP_PHONE_NUMBER_CLICK = 'SP_Phone_Number_Click'; 
export const CUSTOMER_PHONE_NUMBER_CLICK = 'Customer_Phone_Number_Click';
export const PARTS_CUSTOMER_PHONE_NUMBER_CLICK = 'Parts_Customer_Phone_Number_Click';
export const PARTS_SP_PHONE_NUMBER_CLICK = 'PARTS_SP_Phone_Number_Click';
export const NCC_SP_PHONE_NUMBER_CLICK = 'NCC_SP_Phone_Number_Click';
export const NCC_CUSTOMER_PHONE_NUMBER_CLICK = 'NCC_Customer_Phone_Number_Click';
export const NCC_CINCH_REPLACE_PHONE_NUMBER_CLICK = ' NCC_Cinch_Replace_Phone_Number_Click';
export const NCC_CINCH_VOUCHER_PHONE_NUMBER_CLICK = ' NCC_Cinch_Voucher_Phone_Number_Click';
export const ACCEPT_REPLACEMENT = 'Accept_Replacement';
export const ACCEPT_CLAIM_CREDIT = 'Accept_Claim_Credit';
export const ACCEPT_CLAIM_CREDIT_ONLY = 'Accept_Claim_Credit_Only_Option_Given';
export const SELECT_PAYMENT_OPTION =  'Select_Payment_option_Claim_Credit';
export const CHECK_STATUS = 'Check_Status_payment_by_Cheque_Claim_Credit';
export const SCHEDULE_RETURN_VISIT = 'Schedule_return_visit';
export const NEED_HELP_SEE_OPTIONS_PHONE_CLICK =  'Need_help_with_see_options_cinch_phone_click'

//claim not covered page
export const SR_CLAIM_NOT_COVERED_PAGE = 'SR_PM_INIT_FLOW_CLAIM_NOT_COVERED_PAGE';
export const CLAIM_NOT_COVERED_CINCH_PHONE_CLICK= 'Claim_not_covered_Cinch_Phone_Number_Click';
export const ONE_TIME_COURTESY_NOT_ELIGIBLE_CINCH_PHONE_NUMBER_CLICK = 'One_Time_Courtesy_Not_Eligible_Cinch_Phone_number_click';
export const ONE_TIME_COURTESY_CINCH_PHONE_NUMBER_CLICK = 'One_Time_Courtesy_Cinch_Phone_number_click';
export const NEED_HELP_CINCH_PHONE_NUMBER_CLICK = 'Need_help_Cinch_Phone_number_click';

// scheduleAppointmentsPage
export const SCHEDULE_APP_CINCH_ERROR_PHONE_CLICK = 'Error_Message_Cinch_Phone_Number_Click';
export const REVIEW_PAGE_RECALL_NOT_BOOKED_CLICK = 'Cinch_Phone_Number_Click_Recall_not_booked';

export const CANCEL_PLAN = 'cancel_plan';
export const CANCEL_PLAN_DO_NOT_AUTO_RENEW = 'cancel_plan_do_not_renew';
export const PLAN_DETAILS = 'Plan Details';
export const CANCEL_SR = 'Cancel_SR';
export const CANCEL_AMOUNT_DUE = 'cancellation_amount_due';
export const ACCEPT_OFFER_LOCATION = 'PLAN_CANCELLATION_CHOOSE_CANCELLATION_REASON_PAGE';
export const ACCEPT_OFFER_BTN = 'Accept_Offer_Click';
export const REJECT_OFFER_BTN = 'Reject_Offer_Click';
export const CANCEL_PLAN_BACK_TO_HOME_BTN = 'Back_To_Home_Click';


//automatic descisioning
export const SR_PM_INIT_AD_PAGE = 'SR_PM_INIT_AD_FLOW_REPLACEMENT_CLAIM_CREDIT_PAGE';
export const SR_PM_INIT_AD_CINCH_PHONE_CLICK= 'Cinch_On_Page_Phone_Number_Click';
export const SR_PM_INIT_AD_NOTES_PHONE_CLICK = 'Cinch_Notes_Phone_Number_Click';


//my-plan page
export const MY_PLAN_RETENTION_PHONE_CLICK = 'Retention_Phone_Number_Call_to_Cancel_CLICK';
export const  RETENTION_PHONE_NUMBER_CALL_TO_CANCEL_ERROR_MSG_CLICK= 'Retention_Phone_Number_Call_to_Cancel_Error_message_CLICK'
export const CANCEL_PLAN_LOCATION = 'Cancel_Plan';
export const CANCEL_RETENTION_PHONE_CLICK = 'Retention_Phone_Number_CLICK_Offer_Message';
export const CANCEL_RETENTION_HOME_SOLD_PHONE_CLICK='Retention_Phone_Number_CLICK_Home_Sold_Message';
export const CANCEL_RETENTION_NO_OFFER_PHONE_CLICK =  'Retention_Phone_Number_CLICK_No_Offer_Avaiable';
export const CANCEL_RETENTION_PHONE_PLAN_CANCELLED = 'Retention_Phone_Number_CLICK_Plan_Cancelled';
//Profile update
export const PROFILE_CONTACT_INFORMATION_UPDATE = 'Contact_information_update';
export const PROFILE_LOGIN_INFORMATION_UPDATE = 'Login_information_update';
export const PROFILE_MAILING_ADDRESS_UPDATE= 'Profile_Update_Mailing_address_update';
export const PROFILE_PROPERTY_ADDRESS_UPDATE= 'Property_address_update_CE';
export const EDIT_PROFILE_CONTACT_INFORMATION_UPDATE = 'Edit_Contact_information_update';
export const EDIT_PROFILE_LOGIN_INFORMATION_UPDATE = 'Edit_Login_information_update';
export const EDIT_PROFILE_MAILING_ADDRESS_UPDATE= 'Edit_Profile_Update_Mailing_address_update';
export const EDIT_PROFILE_PROPERTY_ADDRESS_UPDATE= 'Edit_Property_address_update_CE';

//Registration 
export const REGISTRATION_FLOW_PLAN_LOOKUP= 'Registration_flow_plan_lookup'
export const PLAN_FOUND_PAGE = 'Plan_found_page';
export const EMAIL_ALREADY_EXISTS = 'Email_already_exists';

//Error
export const ERR_EVENT = 'message_shown';

//Technician Not Found
export const TECHNICIAN_NOT_FOUND_PHONE_NUMBER_CLICK= 'Help_Needed_phone_number_click';
export const TECHNICIAN_NOT_FOUND_PAGE= 'Technician_not_found_page';

//ffs banner
export const START_FFS_FLOW = 'Start_FFS_Flow';
export const START_FFS_FLOW_DRYER_VENT_CLEANING = 'Start_FFS_Flow_Dryer_Vent_Cleaning';

export const PURCHASE = {
    label: 'purchase',
    hitType: 'Customer',
    transitionType: 'service request deductible',
};
export const CONFIRMATION = 'Confirmation';
export const CURRENCY_USD = 'USD';
export const CREDIT_CARD = 'Credit Card';
export const PAST_DUE = 'past_due_payment';
export const SERVICE_REQUEST_DEDUCTIBLE= 'Service_request_deductible';
export const PM_DEDUCTIBLE= 'PM_Deductible';
export const JOB_BOOKING_CONFIRMATION_EVENT= 'Job_Booking_Confirmation_Event'
export const DIFF_BET_DEDUCTIBLE = 'Difference_between_deductible';

export const REQUEST_RECALL_SERVICE = 'Yes_Same_Issue_Book_Recall';
export const NO_DIFFERENT_ISSUE = 'No_Different_Issue_New_Job';
export const NO_DEDUCTIBLE= 'No_Deductible';
export const CLOSE_RECALL = 'Close_Recall_Modal';

// service request detail page
export const SEE_OPTIONS_REPLACEMENT_CLAIM_CREDIT = 'See_Options_Replacement_Claim_Credit';

// contact numbers
export const CINCH_CONTACT_NUMBER_CLICK = 'Cinch_Contact_Number_Click';
export const CINCH_CONTACT_NUMBER_CONFIRMATION = 'Cinch_Contact_Number_Click_Confirmation_message';
export const CINCH_CONTACT_NUMBER_ONE_TIME_COURTESY = 'Cinch_Contact_Number_Click_One_Time_Courtesy_Banner';
export const CINCH_CONTACT_NUMBER_AMOUNT_DUE = 'Cinch_Contact_Number_Click_Amount_Due_Payment';
export const SERVICE_PROVIDER_NUMBER_CLICK = 'Service_Provider_Phone_Number_Click';
export const RECALL_ERROR_PHONE_NUMBER = 'Recall_Error_Phone_Number';
export const INCORRECT_INFO_PHONE_NUMBER = 'Incorrect_Info_Phone_Number';
// plan type
export const FFS_PLAN_TYPE = 'Fee_For_Service';

// menu button names
export const MENU_HOME_LINK = 'Home_Link';
export const MENU_MY_PLAN_LINK = 'My_Plan_Link';
export const MENU_MY_SERVICE_REQUESTS_LINK = 'My_Service_Requests_Link';
export const MENU_PAYMENTS_LINK = 'Payments_Link';
export const MENU_PROFILE_SETTINGS_LINK = 'Profile_Settings_Link';
export const MENU_CONTACT_US_LINK = 'Contact_Us_Link';
export const MENU_PERKS_BENEFITS_LINK = 'Perks_Benefits_Link';
export const UPDATE_BILLING_PREFERENCES = 'Update_Billing_Preferences';
export const UPDATE_BILLING_INFO_ERROR_CONTACT_NUMBER = 'Update_Billing_Info_Contact_Number';
export const UPDATE_BILLING_INFO_PAGE_LOCATION = 'Update_Billing_Info_Page';

//Footer
export const FOOTER_DISCLOSURES_LINK = 'Disclosures';
export const FOOTER_PRIVACY_POLICY_LINK = 'Privacy_policy';
export const FOOTER_TERMS_OF_USE_LINK = 'Terms_of_use';
export const DO_NOT_SELL_LINK = 'do_not_sell_or_share_my_personal_information';
export const FOOTER_LABEL = 'Footer';


export const BILLING_PREFERENCES_UPDATED_CC = 'Billing_Preferences_Updated_CC';
export const BILLING_PREFERENCES_UPDATED_BANK = 'Billing_Preferences_Updated_Bank';

export const BUTTON_LOCATION_PAYMENTS_FROM_HISTORY = 'Payments_page_coming_from_payments_history_page';
export const BUTTON_LOCATION_PAYMENTS_FROM_PROFILE = 'Payments_page_coming_from_profile_page';
export const BUTTON_LOCATION_PAYMENTS_FROM_UNKNOWN = 'Payments_page_coming_from_unknown_page';
export const BUTTON_LOCATION_PAYMENTS_FROM_MYPLANS = 'Payments_page_coming_from_my_plans_page';
export const BUTTON_LOCATION_PAYMENTS_FROM_DASHBOARD = 'Payments_page_coming_from_dashboard_page';
export const BUTTON_LOCATION_PAYMENTS_FROM_SERVICE_REQUESTS = 'Payments_page_coming_from_service_requests_history_page';

export const PAY_PAST_DUE = 'Pay_Past_Due';
export const RED_BANNER = 'Red_Banner';
export const FORGET_PASSWORD_PAGE = 'Forget_password_page';
export const RESEND_EMAIL = 'Resend_Email';

export const VIVR_SR_LIST = 'VIVR_SR_LIST';
export const VIVR_SR_DETAILS = 'VIVR_SR_DETAILS';

export const VIVR_LOGIN_SIGNUP_LABEL = "Login_SignUP";
export const VIVR_SR_INIT_FLOW = "VIVR_SR_Init_Flow";
export const VIVR_SERVICE_DETAIL_LABEL = 'Service details';

export const VIVR_LOGIN_BUTTON_CLICK =  'VIVR_Login_Button_Click';

export const UNLINK_PLAN_LABEL = 'Unlink_Plan';
export const CONFIRM_UNLINK_PLAN_LABEL = 'Confirm_Unlink_Plan';
export const MY_PLANS_PAGE = "My_Plans_Page";
export const  LOGIN_WELCOME_BACK_LABEL = "Login_Welcome_Back";

// CROSS SELL CE
export const CROSS_SELL_CE_CALL_BUTTON = 'Cross_Sell_CE_Call_Button';
export const CROSS_SELL_CE_LANDING_PAGE_BUTTON = 'Cross_Sell_CE_Landing_page_Button';
export const LANDING_PAGE_CROSS_SELL_CE_FROM_DASHBOARD = 'Landing_page_Cross_Sell_CE_From_Dashboard';
export const LANDING_PAGE_CROSS_SELL_CE_FROM_SR_CONFRIMATION = 'Landing_page_Cross_Sell_CE_From_SR_Confirmation';
export const LANDING_PAGE_CROSS_SELL_CE_FROM_SR_CONFRIMATION_VIVR = 'Landing_page_Cross_Sell_CE_From_SR_Confirmation_VIVR';
export const LANDING_PAGE_CROSS_SELL_CE_FROM_MY_PLAN = 'Landing_page_Cross_Sell_CE_From_My_Plan';
export const CALL_BUTTON_CROSS_SELL_CE_LANDING_PAGE = 'Call_for_Cross_sell_DTC_CE_landing_page';
// CE Enrollment flow button names
export const CE_START_ENROLL_FLOW = 'CE_Start_Enroll_Flow';
export const CE_CONTINUE_CONTACT_DETAILS_PAGE = 'CE_Continue_Contact_Details_page';
export const CE_BACK_CONTACT_DETAILS_PAGE = 'CE_Back_Contact_Details_page';
export const CE_ENROLLMENT_PRINT = 'CE_Enrollment_print';
export const CE_ENROLLMENT_IS_DONE = 'CE_Enrollment_Is_Done';
export const CE_ENROLLMENT_ERROR = 'CE_Enrollment_Error';
export const CE_PLAN_LINK_SUCCESS = 'CE_Plan_Link_Success';
export const CE_PLAN_LINK_FAILURE = 'CE_Plan_Link_Failure';
export const SUBMIT_LEAD = 'Submit_Lead';
export const CROSS_SELL_CE_DASHBOARD_LOCATION = 'Cross_Sell_CE_Card_Dashboard';
export const CROSS_SELL_CE_SR_CONFIRMATION = 'Cross_Sell_CE_Card_SR_Confirmation';
export const CROSS_SELL_CE_MY_PLAN_LOCATION = 'Cross_Sell_CE_Card_My_Plan';
// BANNER DISPLAY EVENTS
export const CE_CROSS_SELL_DTC_BANNER_DISPLAYED_ON_DASHBOARD = 'CE_Cross_Sell_DTC_banner_Displayed_On_Dashboard';
export const CE_CROSS_SELL_DTC_BANNER_DISPLAYED_ON_SR_CONFIRMATION_LOGGEDIN = 'CE_Cross_Sell_DTC_banner_Displayed_On_SR_Confirmation_Loggedin';
export const CE_CROSS_SELL_DTC_BANNER_DISPLAYED_ON_SR_CONFIRMATION_VIVR = 'CE_Cross_Sell_DTC_banner_Displayed_On_SR_Confirmation_VIVR';
export const CE_CROSS_SELL_SEARS_BANNER_DISPLAYED_ON_DASHBOARD = 'CE_Cross_Sell_SEARS_banner_Displayed_On_Dashboard';
export const CE_CROSS_SELL_SEARS_BANNER_DISPLAYED_ON_SR_CONFIRMATION_LOGGEDIN = 'CE_Cross_Sell_SEARS_banner_Displayed_On_SR_Confirmation_Loggedin';
export const CE_CROSS_SELL_SEARS_BANNER_DISPLAYED_ON_SR_CONFIRMATION_VIVR = 'CE_Cross_Sell_SEARS_banner_Displayed_On_SR_Confirmation_VIVR';
export const CE_CROSS_SELL_DTC_BANNER_DISPLAYED_ON_MY_PLAN = 'CE_Cross_Sell_DTC_banner_Displayed_On_My_Plan';
export const CE_CROSS_SELL_SEARS_BANNER_DISPLAYED_ON_MY_PLAN = 'CE_Cross_Sell_SEARS_banner_Displayed_On_My_Plan';

// CROSS SELL SURGE
export const CROSS_SELL_SURGE_CALL_BUTTON = 'Cross_Sell_Surge_Call_Button';
export const CROSS_SELL_SURGE_LANDING_PAGE_BUTTON = 'Cross_Sell_Surge_Landing_page_Button';
export const CROSS_SELL_SURGE_DASHBOARD_LOCATION = 'Cross_Sell_Surge_Card_Dashboard';
export const CROSS_SELL_SURGE_SR_CONFIRMATION = 'Cross_Sell_Surge_Card_SR_Confirmation';
export const SURGE_OFFER_SHOWN_SAMS_CUSTOMER = 'SURGE_OFFER_SHOWN_SAMS_CUSTOMER';

export const NO_PLAN_FOUND_MESSAGE = 'No plan found';

export const getToastGa4ButtonName = (planStatus: string): string => {
    const status = planStatus.toLowerCase();
    switch (status) {
        case CONTRACT_STATUS_CANCELLED.toLowerCase():
        return RETENTION_COME_BACK_PLAN_CANCELLED;
        case CONTRACT_STATUS_EXPIRED.toLowerCase():
        return RETENTION_COME_BACK_PLAN_EXPIRED;
        default:
        return RETENTION_PHONE_CLICK;
    }
}
// Alert card constants
export const UPDATE_PAYMENT_METHOD_BANNER_BUTTON = 'Update_Payment_Method_Banner_Button';
export const RE_PLAN_RENEWAL_BUTTON = 'RE_Plan_Renewal_Button';
export const ALERT_ABOUT_PAYMENT_METHOD = 'Alert_About_Payment_Method';
export const PROCURE_VENDOR_SP_JOB_CONFIRMATION = 'Procure_Vendor_SP_JOB_Confirmation';
export const ALERT_ABOUT_RE_RENEWAL = 'Alert_About_RE_Renewal';

export const USER_NOT_ELIGIBLE = 'User is not eligible for one time courtesy based on their contract and claim history';

//action Required view details
export const ACTION_REQUIRED__VIEW_DETAILS_BUTTON = 'Action_Required_View_Details';


export const INSTRUCTIONS_AI_POC_IMAGE = 'Instructions_AI_POC_IMAGE';

// MyPlanStory
export const MY_PLAN_STORY_FEEDBACK_EVENT = 'my_plan_story_feedback';
export const MY_PLAN_STORY_LOCATION = 'My_Plan_Story_Card';

// MyPlanStory renewal - AI message shown, bucketed by claims filed this
// contract period (see IPlanStoryContext.claimsFiledThisYear)
export const RE_ALERT_RENEWAL_AI_ITEM0_MESSAGE = 'RE_Alert_Renewal_AI_Item0_message';
export const RE_ALERT_RENEWAL_AI_ITEM1_MESSAGE = 'RE_Alert_Renewal_AI_Item1_message';
export const RE_ALERT_RENEWAL_AI_ITEM_MORE_MESSAGE = 'RE_Alert_Renewal_AI_Item_more_message';

// MyPlanStory renewal - Renew button click, same item-count bucketing as above
export const RE_RENEWAL_ITEM0 = 'RE_Renewal_Item0';
export const RE_RENEWAL_ITEM1 = 'RE_Renewal_Item1';
export const RE_RENEWAL_ITEM_MORE = 'RE_Renewal_Item_more';

export const getReRenewalAiMessageEvent = (itemCount: number): string => {
    if (itemCount <= 0) return RE_ALERT_RENEWAL_AI_ITEM0_MESSAGE;
    if (itemCount === 1) return RE_ALERT_RENEWAL_AI_ITEM1_MESSAGE;
    return RE_ALERT_RENEWAL_AI_ITEM_MORE_MESSAGE;
};

export const getReRenewalButtonEvent = (itemCount: number): string => {
    if (itemCount <= 0) return RE_RENEWAL_ITEM0;
    if (itemCount === 1) return RE_RENEWAL_ITEM1;
    return RE_RENEWAL_ITEM_MORE;
};
